<template>
  <v-data-table
    :loading="loading"
    :items="orders"
    :headers="headers"
    disable-pagination
    hide-default-footer
    :sort-by="['date']"
    :sort-desc="[true]"
    mobile-breakpoint="0"
  >
    <template #[`item.id`]="{ item }">
      <router-link :to="`/orders/${item.id}`">
        {{ item.id }}
      </router-link>
    </template>
    <template #[`item.date`]="{ item }">
      {{ item.date | normalDate }}
    </template>
    <template #[`item.total`]="{ item }">
      {{ item.total | currency }}
    </template>
  </v-data-table>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'UserPayouts',
  data: () => {
    return {
      headers: [
        { text: 'Id', value: 'id' },
        { text: 'Date', value: 'date' },
        { text: 'Type', value: 'type' },
        { text: 'Total', value: 'total' },
        { text: '', value: 'actions', sortable: false }
      ],
      loading: false
    };
  },
  computed: {
    ...mapGetters({
      user: 'users/user',
      orders: 'users/orders'
    })
  },
  mounted() {}
};
</script>
